import React, { createContext, useState } from 'react';
import { createContextHook } from '../contextUtils';

// DataContext manages all data-related states for visualizations
const DataContext = createContext();

export function DataProvider({ children }) {
  // Raw data for main visualization
  const [json, setJson] = useState(null);  
  // Processed data for current view
  const [viewJson, setViewJson] = useState([]);  
  // India-level data for comparisons
  const [indiaJson, setIndiaJson] = useState([]);  
  // Data formatted for line charts
  const [lineData, setLineData] = useState(null);  
  // Year markers for timeline controls
  const [yearMarks, setYearMarks] = useState({});  
  // Timeline range controls
  const [minYear, setMinYear] = useState(0);
  const [maxYear, setMaxYear] = useState(0);
  const [sliderRange, setSliderRange] = useState(null);  
  // Geographic entity names and codes
  const [districtNames, setDistrictNames] = useState([]);
  const [districtStateNames, setDistrictStateNames] = useState(null);
  const [selectedStateCode, setSelectedStateCode] = useState("");
  const [stateNames, setStateNames] = useState(null);
  const [geographies, setGeographies] = useState(null);

  // Comparison visualization states (parallel to main visualization states)
  const [compJson, setCompJson] = useState(null);  const [compViewJson, setCompViewJson] = useState([]);
  const [compIndiaJson, setCompIndiaJson] = useState([]);
  const [compLineData, setCompLineData] = useState(null);
  const [compYearMarks, setCompYearMarks] = useState({});
  const [compMinYear, setCompMinYear] = useState(0);
  const [compMaxYear, setCompMaxYear] = useState(0);
  const [compSliderRange, setCompSliderRange] = useState(null);

  const value = {
    json, setJson,
    viewJson, setViewJson,
    indiaJson, setIndiaJson,
    lineData, setLineData,
    yearMarks, setYearMarks,
    minYear, setMinYear,
    maxYear, setMaxYear,
    sliderRange, setSliderRange,
    districtNames, setDistrictNames,
    districtStateNames, setDistrictStateNames,
    selectedStateCode, setSelectedStateCode,
    stateNames, setStateNames,
    geographies, setGeographies,
    // compared visualization
    compJson, setCompJson,
    compViewJson, setCompViewJson,
    compIndiaJson, setCompIndiaJson,
    compLineData, setCompLineData,
    compYearMarks, setCompYearMarks,
    compMinYear, setCompMinYear,
    compMaxYear, setCompMaxYear,
    compSliderRange, setCompSliderRange
  };

  return (
    <DataContext.Provider value={value}>
      {children}
    </DataContext.Provider>
  );
}

export const useData = createContextHook(DataContext, 'useData');